import { render } from "./serviceCard.vue?vue&type=template&id=d129648e&scoped=true"
import script from "./serviceCard.vue?vue&type=script&lang=js"
export * from "./serviceCard.vue?vue&type=script&lang=js"

import "./serviceCard.vue?vue&type=style&index=0&id=d129648e&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d129648e"]])

export default __exports__